import { useEffect, useState } from "react";
import { AlertTriangle, Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { useQuota } from "../context/QuotaContext";
import api, { apiErr } from "../lib/api";

export default function PaymentDueBanner() {
  const { quota, refreshQuota } = useQuota();
  const { t } = useTranslation();
  const [opening, setOpening] = useState(false);
  const overdue = quota?.payment_overdue;
  useEffect(() => {
    if (!overdue) return;
    const refresh = () => { if (document.visibilityState === "visible") refreshQuota(); };
    window.addEventListener("focus", refresh);
    const interval = window.setInterval(refresh, 30000);
    return () => { window.removeEventListener("focus", refresh); window.clearInterval(interval); };
  }, [overdue, refreshQuota]);
  if (!overdue) return null;

  const pay = async () => {
    setOpening(true);
    try {
      const { data } = await api.post("/payments/outstanding-invoice");
      if (data.paid) { await refreshQuota(); toast.success(t("paymentDue.paid")); }
      else if (data.url) window.location.assign(data.url);
    } catch (error) { toast.error(apiErr(error)); }
    finally { setOpening(false); }
  };

  return (
    <div role="alert" data-testid="payment-due-banner" className="border-b border-rose-200 bg-rose-50 px-4 py-3 text-rose-900">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center gap-3">
        <AlertTriangle size={21} className="shrink-0" />
        <div className="min-w-0 flex-1">
          <p className="font-semibold">{t("paymentDue.title")}{quota.payment_due_amount ? ` (${quota.payment_due_amount})` : ""}</p>
          <p className="text-sm">{t("paymentDue.body")}</p>
        </div>
        <button type="button" onClick={pay} disabled={opening} className="flex items-center gap-2 rounded-lg bg-rose-700 px-4 py-2 text-sm font-semibold text-white hover:bg-rose-800 disabled:opacity-60">
          {opening && <Loader2 size={16} className="animate-spin" />}{t("paymentDue.cta")}
        </button>
      </div>
    </div>
  );
}
